import React, { useEffect, useState } from 'react';
import DashboardContent from '../../../dashboardWrapper/DashboardContent';
import Wrapper from '../../../dashboardWrapper/Wrapper';
import DashboardMainTitle from '../../../dashboardTitle/DashboardMainTitle';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllTicketsPagination, fetchGetAllTickets } from '../../../../redux/action/tickets/getAllTicket';
import MainLoading from '../../../../utils/MainLoading';
import { Pagination, Table } from 'react-bootstrap';
import moment from "moment-jalaali";
import AdminSingleTicket from './AdminSingleTicket';
import { useTranslation } from 'react-i18next';

const AdminTicketsView = () => {
    const [showTicket, setShowTicket] = useState(false)
    const [ticketId, setTicketId] = useState('')
    const dispatch = useDispatch()
    const tickets = useSelector(state => state.get_all_tickets)
    const {t} = useTranslation();
    const lang = localStorage.getItem('lang')

    useEffect(() => {
        if(!tickets.get_all_tickets.tickets) {
            dispatch(fetchGetAllTickets())
        }
    }, [])

    const handlePaginate = (e) => {
        e.preventDefault()
        dispatch(fetchAllTicketsPagination(e.target.href))
    }

    const handleTicket = (id) => {
        setShowTicket(true)
        setTicketId(id)
    }

    const close = () => {
        setShowTicket(false)
        window.scrollTo(0, 0)
    }

    return (
        <Wrapper>
            <DashboardContent>
                {showTicket ?
                    <AdminSingleTicket id={ticketId} close={close} />
                :
                    <>
                    <DashboardMainTitle>{t("dashboard_nav_tickets")}</DashboardMainTitle>
                    {tickets.loading ?
                        <MainLoading />
                    :
                    tickets.get_all_tickets.tickets && tickets.get_all_tickets.tickets.data &&
                        tickets.get_all_tickets.tickets.data.length ?
                            <>
                            <Table bordered responsive>
                                <thead>
                                    <tr>
                                        <th className='col-lg-2'> {t("Importance")} </th>
                                        <th className='col-lg-2'> {t("title")} </th>
                                        <th className='col-lg-2'> {t("date")} </th>
                                        <th className='col-lg-2 text-center'>{t("management")} </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tickets.get_all_tickets.tickets.data.map(ticket => (
                                        <tr key={ticket.id} style={{background: ticket.state === "CLOSED" ? 'rgb(230, 230, 230)' : '#fff'}}>
                                            <td> {ticket.priority === "HIGH" ? t("high") : ticket.priority === "MID" ? t("mid") : t("low")} </td>
                                            <td> {ticket.subject} </td>
                                            <td> 
                                                {lang === 'en'?
                                                    ticket.created_at.substr(11, 5)+' - '+ticket.created_at && ticket.created_at.substr(0, 10)
                                                :
                                                    ticket.created_at.substr(11, 5)+' - '+moment(ticket.created_at && ticket.created_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                                                }
                                            </td>
                                            <td className='text-center'>
                                            {ticket.state === "CLOSED" ?
                                                <button className='btn btn-secondary btn-sm px-3' onClick={id => handleTicket(ticket.id)}>{t("management")}</button>
                                            :
                                                <button className='btn btn-primary btn-sm px-3' onClick={id => handleTicket(ticket.id)}>{t("management")}</button>
                                            }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className='pagination_container mt-3'>
                                <Pagination>
                                    {tickets.get_all_tickets.tickets.links ? tickets.get_all_tickets.tickets.links.map(link => (
                                        <Pagination.Item href={link.url} disabled={link.url ? false : true} active={link.active} key={link.label} onClick={id => {handlePaginate(id)}}>
                                            {link.label.replace('&laquo;', '').replace('&raquo;', '')}
                                        </Pagination.Item>
                                    )) : ''}
                                </Pagination>
                            </div>
                        </>
                    :
                            <h6 className='text-center'>{t("There is no Ticket")}</h6>
                    }
                    </>
                }
            </DashboardContent>
        </Wrapper>
        )
}

export default AdminTicketsView;
